import { useContext, useState } from 'react';
import { BorderOuterOutlined, ClearOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Col, Row, Slider, Tooltip } from 'antd';
import ColorPicker, { Color } from 'antd/es/color-picker';
import { FileCenterContext, IFileCenterContext } from '@/common/components/FileCenterProvider';
import CircleAddBtn from '@/components/WorkSpace/components/CircleAddBtn';
import { customColors } from '@/components/Sidebar/constants';
import { RGBA } from '@/common/constants/interfaces';


function FontStroke() {
    const { stroke, setStroke } = useContext<IFileCenterContext>(FileCenterContext);
    // 描边面板是否展开收起
    const [isStrokeFold, setIsStrokeFold] = useState<boolean>(false);

    function handleAddStroke() {
        setStroke({
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 3
        })
    }

    function handleRemoveStroke() {
        setStroke(null)
    }

    function handleFoldStroke() {
        setIsStrokeFold(!isStrokeFold)
    }

    function handleStrokeColorChange(color: Color) {
        if (!stroke) {
            return;
        }
        setStroke({
            ...stroke,
            strokeColor: RGBA.fromHex(color.toHexString()),
        })
    }

    function handleStrokeWidthChange(value: number) {
        if (!stroke) {
            return;
        }
        setStroke({
            ...stroke,
            strokeWidth: value,
        })
    }

    return (
        <>
            <div className='line-between'>
                <div className='text'> <BorderOuterOutlined className='margin-right-6' />描边</div>
                <div>
                    {!stroke && <CircleAddBtn onClick={handleAddStroke} title='添加描边' />}
                    {stroke && (
                        <div>
                            <Tooltip placement="bottom" title="删除描边配置">
                                <Button shape="circle" size="small" type="text" icon={<ClearOutlined />} onClick={handleRemoveStroke} />
                            </Tooltip>
                            {
                                isStrokeFold && (
                                    <Tooltip placement="bottom" title="展开描边配置">
                                        <Button className='margin-left-8' shape="circle" size="small" type="text" icon={<DownOutlined />} onClick={handleFoldStroke} />
                                    </Tooltip>
                                )
                            }
                            {
                                !isStrokeFold && (
                                    <Tooltip placement="bottom" title="收起描边配置">
                                        <Button className='margin-left-8' shape="circle" size="small" type="text" icon={<UpOutlined />} onClick={handleFoldStroke} />
                                    </Tooltip>
                                )
                            }
                        </div>

                    )}
                </div>
            </div>
            {
                (stroke && !isStrokeFold) && (
                    <div className='line-between'>
                        <div className='text'> 颜色</div>
                        <ColorPicker size='small' value={stroke.strokeColor.toHexString()} presets={customColors} onChange={handleStrokeColorChange} />
                    </div>
                )
            }

            {
                (stroke && !isStrokeFold) && (
                    <Row>
                        <Col span={6} className='text'>
                            粗细
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={10}
                                step={1}
                                onChange={handleStrokeWidthChange}
                                value={stroke.strokeWidth}
                            />
                        </Col>
                    </Row>
                )
            }
        </>
    );
}

export default FontStroke;